module.exports = __webpack_public_path__ + "static/img/Round-05-2015.720063b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-05-2015.jpg
// module id = G9Tq
// module chunks = 0